import React from "react";
import TextareaAutosize from "react-textarea-autosize";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { catalogTableLabel } from "../../../app/helpers/helperCatalogs";

const EditableRow = ({
  editFormData,
  handleEditFormChange,
  handleCancelClick,
  handleEditFormSubmit,
  comboData
}) => {

    const { t } = useTranslation();

  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      
      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
  };

  return (
    <tr>
      <td style={{width:'40%'}}>
        <Select
          styles={customStyles}
          
          myFontSize="14px"
          style={{ width: "100%" }}
          
          onChange={(event) => handleEditFormChange(event, "CatProblem_To_ModProblem", "relation")}
          
          classNamePrefix="select"
          
          name="CatProblem_To_ModProblem"
          
          inputId="CatProblem_To_ModProblem"
          
          value={editFormData.CatProblem_To_ModProblem}

          options={comboData}
          getOptionLabel={(option) => catalogTableLabel(option)}
          getOptionValue={(option) => `${option}`}
          isClearable={true}
          isSearchable={true}
          placeholder={t('experience.table_problems.problems')}
        />
      </td>
      <td style={{width:'25%'}}>
        <TextareaAutosize
          cacheMeasurements
          className="form-control"
          aria-label="empty textarea"
          style={{ width: "100%" }}
          onChange={(event) => handleEditFormChange(event, "matter", "text")}
          
          maxRows={5}
          name="matter"
          id="matter"
          value={editFormData.matter}
          required
          maxLength="200"
          placeholder={t('experience.table_problems.matter')}
        ></TextareaAutosize>
      </td>
      <td style={{width:'25%'}}>
        <TextareaAutosize
          cacheMeasurements
          className="form-control"
          aria-label="empty textarea"
          style={{ width: "100%" }}
          onChange={(event) => handleEditFormChange(event, "solution", "text")}
          
          maxRows={5}
          name="solution"
          id="solution"
          value={editFormData.solution}
          required
          maxLength="200"
          placeholder={t('experience.table_problems.solution')}
        ></TextareaAutosize>
      </td>
      {/*<td>
      {showComponentPreviewFile(editFormData.url)}
      </td>*/}
      <td style={{width:'10%'}}>
        {/*<button type="submit">Save</button>*/}
        <button style={{border:'none'}} onClick={handleEditFormSubmit}> 
        <i className="fa fa-save table-button-save"></i>
        </button>
        <button style={{border:'none'}} type="button" onClick={handleCancelClick}>
        <i className="fa fa-times-circle table-button-cancel"></i>
        </button>
      </td>
    </tr>
  );
};

export default EditableRow;
